'use client'
import classNames from 'classnames'
import React, { useState } from 'react'
import styles from './LocationScrollDrawer.module.scss'
import { Translator } from '@/tools/i18n'
import { useLocalisation } from '@/tools/i18n/client'
import { ArrowForwardIcon, BaseInput, InputSize, LocationMarkerIcon } from '@/tools/ui'
import { HighlightText } from '@/tools/ui'
import { AddressBookModal } from '@/user/address-book/ui/AddressBookModal'

interface Props {
  isShown: boolean
}

export const LocationScrollDrawer: React.FC<Props> = ({ isShown }) => {
  const { t } = useLocalisation()
  const [showAddressBook, setShowAddressBook] = useState<boolean>(false)

  const handleOnModalClose = () => {
    setShowAddressBook(false)
  }
  const handleOnModalOpen = () => {
    setShowAddressBook(true)
  }

  return (
    <div
      className={classNames({
        [styles.locationScrollDrawer]: true,
        [styles.shown]: isShown,
      })}
    >
      <div className={styles.locationScrollDrawer__title}>
        <div className="pintxo-typography-callout1">
          <Translator
            keyText="header.address-input.title"
            params={{
              highlight: (
                <HighlightText
                  text={t('header.address-input.highlight')}
                  textClass="pintxo-typography-callout1"
                />
              ),
            }}
          />
        </div>
      </div>
      <div className={styles.addressButtonWrapper}>
        <BaseInput
          leadingIcon={LocationMarkerIcon}
          placeholder={t('landing.address-picker')}
          readonly={true}
          size={InputSize.medium}
          trailingIcon={ArrowForwardIcon}
          onClick={handleOnModalOpen}
        />
        <AddressBookModal
          isOpen={showAddressBook}
          onClose={handleOnModalClose}
          onSelect={handleOnModalClose}
        />
      </div>
    </div>
  )
}
